import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import useLogin from './useLogin';
import useYupValidationResolver from './useYupValidationResolver';
import { getSignInValidationSchema } from '../helpers/validationSchemaHelper';
import { SIGN_IN_DEFAULT_VALUES } from '../constants/login';
import useTurnstile from './useTurnstile';

function useSignIn() {
  const [forgotPassword, setForgotPassword] = useState(false);
  const resolver = useYupValidationResolver(getSignInValidationSchema(forgotPassword));

  const { register, handleSubmit, errors, reset } = useForm({ resolver, defaultValues: SIGN_IN_DEFAULT_VALUES });
  const { submitSignIn, submitForgotPassword } = useLogin();
  const { turnstileToken, ensureTurnstileToken, resetTurnstile, turnstileProps } = useTurnstile();

  // This one form serves both sign in and the password reset request. Only the
  // latter is behind Turnstile, so signing in is left exactly as it was.
  async function handleSubmitForm(data) {
    if (!forgotPassword) {
      reset();

      return submitSignIn(data);
    }

    if (!ensureTurnstileToken()) {
      return undefined;
    }

    reset();

    const succeeded = await submitForgotPassword({ ...data, turnstile_token: turnstileToken });

    if (!succeeded) {
      resetTurnstile();
    }

    return undefined;
  }

  return {
    handleSubmitForm: handleSubmit(handleSubmitForm),
    register,
    errors,
    forgotPassword,
    setForgotPassword,
    turnstileProps,
  };
}

export default useSignIn;
